const API_BASE = process.env.REACT_APP_BACKEND_URL;
const TOKEN_KEY = 'ybv_auth_token';

/**
 * Authenticated fetch — injects the Bearer token from localStorage
 * into every request. Drop-in replacement for window.fetch.
 */
export async function authFetch(path, options = {}) {
  const token = localStorage.getItem(TOKEN_KEY);
  const headers = {
    ...options.headers,
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
  return fetch(`${API_BASE}${path}`, { ...options, headers });
}
